//@flow
import React from 'react';
import Icon from '../../Icon/components/Icon.react';
import FiltersActions from '../../Actions/filters';
import AccessibleButtonWrapper from '../../Icon/components/AccessibleButtonWrapper.react';

type Props = {
  name:string,
  text:string,
};

export default class FilterPill extends React.Component<Props> {
  _removeFilter = () => {
    FiltersActions.removeFilter(this.props.name);
  }

  render() {
    return (
      <div className="filter-pill">{this.props.text}
        <AccessibleButtonWrapper
          label={this.props.text}
          action={this._removeFilter}
        >
          <Icon
            className="x-icon"
            size="0.9rem"
            icon="x"
            style={{ verticalAlign: 'baseline' }}
          />
        </AccessibleButtonWrapper>
      </div>
    );
  }
}
